var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"forget"}},[_c('div',{staticClass:"forget__wrapper"},[_c('div',[_c('img',{staticClass:"forget_wrapper__logo mb-4",attrs:{"src":require("../../../assets/images/logo-S.svg")}}),_c('forgot')],1)]),_c('Notes')],1)}
var staticRenderFns = []

export { render, staticRenderFns }